import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, getNoAuthCallParams, makeCall } from "../../../../utils/service";

export async function getClosureReportDetails(payload:any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETCLOSUREREPORT}?start_date=${payload.startDate}&end_date=${payload.endDate}&team_id=${payload.teamId}&page=${payload.pageNumber}&limit=${payload.pageSize}&usersId=${payload.usersId}&search=${payload.search}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}


